export default {
    home:{
      webPage:'网页',
      picture:'图片'
    }
}